/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ company: NonNullable<unknown> }} Signup_Invitation_Existing_User_PromptInputs */

const es_co2_signup_invitation_existing_user_prompt = /** @type {(inputs: Signup_Invitation_Existing_User_PromptInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Esta invitación es para una cuenta existente. Inicia sesión para unirte a ${i?.company}.`)
};

/**

* @param {Signup_Invitation_Existing_User_PromptInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const signup_invitation_existing_user_prompt = /** @type {((inputs: Signup_Invitation_Existing_User_PromptInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signup_Invitation_Existing_User_PromptInputs, { locale?: "es-CO" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_signup_invitation_existing_user_prompt(inputs)
});